import React from 'react';
import { useIconThemed } from '../use-icon-themed';
export default function IconPanelNote() {
  var _useIconThemed = useIconThemed(),
    iconThemed = _useIconThemed.iconThemed;
  return /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    "aria-hidden": true,
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    }),
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: iconThemed({
      light: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
      dark: "var(--ds-background-accent-purple-subtlest, #F3F0FF)"
    }),
    x: 8,
    y: 12,
    width: 32,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16h4a1 1 0 011 1v6a1 1 0 01-1 1h-4a1 1 0 01-1-1v-6a1 1 0 011-1zm1 2a.5.5 0 100 1h2a.5.5 0 100-1h-2zm0 2a.5.5 0 100 1h1a.5.5 0 100-1h-1z",
    fill: iconThemed({
      light: "var(--ds-icon-discovery, #8270DB)",
      dark: "var(--ds-icon-discovery, #8270DB)"
    })
  })));
}